<template>
    <section class="section-80 section-lg-60">
        <div class="container">
            <div class="nav-custom row d-flex flex-row justify-center align-center mb-5" v-if="!forgot">
                <button class="nav-custom col-md-2 col-4 text-center px-0 active" :class="{neew : login}"  style="border:1px solid #d7d7d7; padding:8px 15px;" @click="log()">Login</button>
                <button class="nav-custom col-md-2 col-4 text-center px-0" :class="{neew1:register}" style="border:1px solid #d7d7d7; padding:8px 15px;" @click="reg()">Register</button>
            </div>

            <!-- Login Form -->
            <div v-if="login">
                <div class="row row-offset-2 justify-content-sm-center">
                    <div class="col-md-8 col-lg-6 col-xl-4">
                        <v-form ref="loginForm" v-model="valid" @submit.prevent="loginsubmitForm()" class="rd-mailform rd-form text-left">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="login">Username or e-mail</label>
                                <v-text-field v-model="username" class="form-input form-input-gray" id="login" type="text"
                                    :rules="emailRules"></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="password">Password</label>
                                <v-text-field
                                        v-model="password"
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="passwordRules"
                                        :type="show1 ? 'text' : 'password'"
                                        hint=""
                                        label=""
                                        name=""
                                        @click:append="show1 = !show1"
                                        class="form-input form-input-gray"
                                        id="password"
                                    ></v-text-field>
                            </div>
                            <div class="fop">
                                <div><v-checkbox label="Remember Me"></v-checkbox> </div>
                                <div class="mt-5"><a class="undel"  @click="fog()">Forgot Password</a></div>
                            </div>
                            <button class="button button-primary button-block button-sm" type="submit">Sign in</button>
                        </v-form>
                    </div>
                </div>
            </div>

            <!-- Registration Form -->
            <div v-if="register">
                <div class="row row-offset-2 justify-content-sm-center">
                    <div class="col-md-8 col-lg-6 col-xl-4">
                        <v-form ref="registerForm" v-model="valid" @submit.prevent="submitForm()" class="rd-mailform rd-form text-left">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="firstName">First Name</label>
                                <v-text-field v-model="personal.firstName" class="form-input form-input-gray" id="firstName"
                                    type="text" :rules="firstNameRules"></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="login">Middle Name</label>
                                <v-text-field v-model="personal.middleName" class="form-input form-input-gray" id="login" type="text" name="login" data-constraints="@Required"></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="lastName">Last Name</label>
                                <v-text-field v-model="personal.lastName" class="form-input form-input-gray" id="lastName"
                                    type="text" :rules="lastNameRules"></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="phone">Phone Number</label>
                                <v-text-field v-model="personal.phoneNumber" class="form-input form-input-gray" id="phone"
                                    type="text"></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="email">E-mail</label>
                                <v-text-field v-model="personal.email" class="form-input form-input-gray" id="email"
                                    type="text" :rules="emailRules1"></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="password">Password</label>
                                <v-text-field
                                        v-model="personal.password"
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="passwordRules"
                                        :type="show1 ? 'text' : 'password'"
                                        @click:append="show1 = !show1"
                                        class="form-input form-input-gray"
                                        id="password"
                                    ></v-text-field>
                            </div>
                            <div class="form-wrap">
                                <label class="form-label-outside" for="password2">Confirm Password</label>
                                <v-text-field
                                        v-model="personal.rePassword"
                                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="repassWord"
                                        :type="show2 ? 'text' : 'password'"
                                        hint=""
                                        label=""
                                        name=""
                                        @click:append="show2 = !show2"
                                        class="form-input form-input-gray"
                                        id="password"
                                    ></v-text-field>
                            </div>
                            <button class="button button-primary button-block button-sm" type="submit">Register</button>
                        </v-form>
                    </div>
                </div>
            </div>
            <div v-if="forgot">
                <div class="row row-offset-2 justify-content-sm-center">
                    <div class="col-md-10 col-lg-6 col-xl-4">
                    <button class="nav-custom col-md-4 col-4 text-center px-0 active" :class="{neew2 : forgot}"  style="border:1px solid #d7d7d7; padding:8px 15px;">Login</button>
                <v-form ref="loginForm" v-model="valid" @submit.prevent="Forgotform()" class="rd-mailform rd-form text-left">
                    <div class="form-wrap">
                    <label class="form-label-outside" for="login">Username or e-mail</label>
                    <v-text-field v-model="resetDetail.resetMail" class="form-input form-input-gray" id="login" type="text"
                    :rules="emailRules2"></v-text-field>
                    <div class="fop">
                     <div><v-checkbox label="Remember Me"></v-checkbox> </div>
                     <div class="mt-4"><a class="undel1" @click="log()">Login</a></div>
                    </div>
                    <button class="button button-primary button-block button-sm" type="submit">Submit</button>
                    </div>
                </v-form>
                </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default {
    data() {
        return {
            show1: false,
            show2: false,
            valid: false,
            login: true,
            register: false,
            username: "",
            password: "",
            registerUrl:"",
            loginUrl:"",
            resetDetail:{
                resetMail:""
            },
            forgetDetails:{
                email:"",
                user_id:"",
                portal_id:"",
                portal_domain:""
            },
            personal: {
                firstName: "",
                lastName: "",
                middleName:"",
                email: "",
                password: "",
                rePassword: "",
                phoneNumber: ""
            },
            loginReq:{
                email:"",
                password:"",
                portal_id:"",
                portal_domain:""
            },
            registerReq:{
                first_name:"",
                middle_name:"",
                last_name:"",
                email:"",
                phoneNumber:"",
                password:"",
                user_id:"",
                portal_id:"",
                portal_group_id:"",
                portal_domain:"",
                request_type: "user_register",
                token: "Tc7RQaX79Hrx5CFK",
            },
            // Validation rules
            firstNameRules: [
                v => !!v || 'Please enter your First Name',
                v => v.length >= 3 || 'Name must be at least 3 characters'
            ],
            lastNameRules: [
                v => !!v || 'Please enter your Last Name'
            ],
            phoneRules: [
                v => !!v || 'Phone number is required',
                v => /^[0-9]+$/.test(v) || 'Only numbers allowed',
                v => v.length === 10 || 'Phone number must be 10 digits'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'Enter a valid e-mail'
            ],
            emailRules1: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'Enter a valid e-mail'
            ],
            emailRules2: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'Enter a valid e-mail'
            ],
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => v.length >= 6 || 'Password must be at least 6 characters'
            ],
        };
    },
    computed: {
        repassWord() {
            return [
                v => !!v || 'Please enter your Re-password',
                v => v === this.personal.password || 'Passwords do not match'
            ];
        }
    },
    methods: {
        loginsubmitForm() {
          console.log(this.valid, 'vvvvaaaallll')
          if (this.valid) {

              this.loadLogin = true
              this.btnDisabled = true

              this.loginReq.email = this.username
              this.loginReq.password = this.password
              this.loginReq.portal_id = this.portal_id
              this.loginReq.portal_domain = this.portal_domain
              
              console.log(this.loginReq, 'kkkk.....')

              axios.post(this.loginUrl, this.loginReq, {
                  headers: {
                      'Content-Type': 'application/json'
                  }
              })
                  .then(response => {
                      console.log('Response:', response.data);
                      localStorage.setItem("loginuser", JSON.stringify(response.data))
                      this.errorMsg = false

                      if(response.data.login_response == "success"){
                          this.loginsuccess = true;
                          this.dialog = true;
                          this.loadforget = false;
                          this.loadLogin = false
                      }

                      // this.loginbox = true

                      localStorage.setItem('value', true)
                      // JSON.stringify(localStorage.setItem('loginDatas', this.loginuser))
                    //   let logindata = JSON.stringify(this.loginuser)
                    //   localStorage.setItem("loginDatas", logindata)

                      // setInterval(() => {
                      //     location.reload();
                      // }, 500);

                  })
                  .catch(error => {
                      console.error('Error:', error.response ? error.response.data : error.message);
                      this.errorMsg = true
                      this.erMsg = error.response.data.message;
                      console.log(this.erMsg,'erMsgerMsg')
                      // alert("Incorrect email or password...")
                      this.loadLogin = false
                      this.btnDisabled = false
                  });
          }

      },
      closeDialog(){
          setInterval(() => {
              location.reload();
          }, 200);
      },
      submitForm() {

console.log(this.valid, 'oooooooooo')
if (this.valid) {

    this.loadRegister = true
    this.btnDisabled = true          // this.generateBookingRefId()

    console.log(this.personal, 'eeeee......')


    this.registerReq.first_name = this.personal.firstName
    this.registerReq.middle_name = this.personal.middleName
    this.registerReq.last_name = this.personal.lastName
    this.registerReq.email = this.personal.email
    this.registerReq.phoneNumber = this.personal.phoneNumber
    this.registerReq.password = this.personal.password
    this.registerReq.user_id = this.personal.email
    this.registerReq.portal_id = this.portal_id
    this.registerReq.portal_group_id = this.portal_group_id
    this.registerReq.portal_domain = this.portal_domain
    // this.registerReq.request_type = this.request_type
    console.log(this.registerReq, 'ffff.....')

    axios.post(this.registerUrl, this.registerReq, {
    headers: {
        'Content-Type': 'application/json'
    }
    })
    .then(response => {

        if (response.data) {
        this.regForm = false
        this.regMsg = true
        console.log('Response:', response.data);
        console.log('Response-Msg:', response.data.register.message);
        this.registerMsg = response.data.register.message

        // this.registerbox = false
        }
    })
    .catch(error => {
        this.regErr = true;
        console.log(error.response.data.message, 'wejjfuoajk')
        // alert(`${error.response.data.message}`)
        this.errorMsg = error.response.data.message
        this.loadRegister = false
        this.btnDisabled = false
    });
}
},

Forgotform(){
    if (this.valid) {
                // this.emailsentMsg = true
                // this.forgotshow = false
                this.loadforget = true

                this.forgetDetails.email = this.resetDetail.resetMail
                this.forgetDetails.user_id = this.resetDetail.resetMail
                this.forgetDetails.portal_id = this.portalId
                this.forgetDetails.portal_domain = this.portal_domain


                console.log(this.forgetDetails, 'reqqqqqqqqqq')

                axios.post(this.forgotPassword, this.forgetDetails, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
}
},




        getConfig() {
          // let portalLocal = localStorage.getItem("portalData")
          // let getConfigData1 = JSON.parse(portalLocal)
          const getConfigData1 = getConfigDataFromLocalStorage();
          if (getConfigData1) {
              this.loginUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2clogin
              this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
              this.forgotPassword = getConfigData1.payload.portal_configuration.API_endpoints.forgot_password
              this.portal_id = getConfigData1.payload.portal_configuration.portal_id
              console.log(this.loginUrl, 'head...reg..1..')
              this.dataloader = false
              this.portal_domain = getConfigData1.payload.portal_configuration.portal_url.replace("https://","");
              this.portal_group_id = getConfigData1.payload.portal_configuration.portal_group_id

          }
      },
        log() {
            this.login = true;
            this.register = false;
            this.valid = false; // Reset validation
            this.forgot = false;
            this.updatepassword=false;

        },
        reg() {
            this.register = true;
            this.login = false;
            this.valid = false; // Reset validation
            this.forgot = false;
            this.updatepassword=false;
            
        },
        fog() {
            this.login = false;
            this.register = false;
            this.valid = false; // Reset validation
            this.forgot = true;
            this.updatepassword=false;

            // document.getElementsByClassName('.nav-custom').style.display = "none"
        },
    },
    created() {
        this.getConfig();
    },
};
</script>

<style scoped>
ul {
    padding-left: 0px;
}

button{
    color: white;
}

.nav-custom {
    border: none;
}

:deep(.v-field__input) {
    background-color: white;
}

:deep(.v-input) {
    padding: 0px;
    display: grid !important;
    justify-content: center;
    align-items: anchor-center;
}
.nav-custom{
    color: gray;
}
/* .nav-custom:focus {
    background-color: #22a9bf;
    color: #fff;
} */
:deep(.v-text-field .v-input__details) {
    padding-inline: 1px;
    background-color: #f1f1f1 !important;
    width: 100%;
}
:deep(.fop .v-input .v-input__details){
    display: none;
}
.form-input {
    border: none !important;
}
.form-wrap + .form-wrap {
    margin-top: 15px;
}
.rd-form * + .button {
    margin-top: 15px;
}
.neew {
  background-color: #22a9bf;
  color: white;
}
.neew1
{
    background-color: #22a9bf;
    color: white;
}
.neew2
{
    background-color: #22a9bf;
    color: white;
    margin-bottom: 10px;
}
.fop
{
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
}
.undel
{
    /* border-bottom: 1px solid #1f2746; */
    color: #1f2746;
    font-weight: 700;
}
.undel:hover{
    cursor: pointer;
}
.undel1
{
    /* border-bottom: 1px solid #1f2746; */
    color: #1f2746;
    font-weight: 700;
    margin-right: 10px;
}
.undel1:hover{
    cursor: pointer;
}
:deep(.v-input--horizontal .v-input__append) {
    margin-inline-start: -35px !important;
}
:deep(.v-input__append)
{
    margin-right: 10px !important;
}
</style>
